import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'fury-exportpdf',
  templateUrl: './exportpdf.component.html',
  styleUrls: ['./exportpdf.component.scss']
})
export class ExportpdfComponent implements OnInit {


  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ExportpdfComponent>) {
  }
  ngOnInit() {
  }


  allcommandepdf(){
    this.dialogRef.close("allcommandepdf");
  }

  livrerpdf(){
    this.dialogRef.close("livrerpdf");
  }

}
